import { render, staticRenderFns } from "./PreviewBox.vue?vue&type=template&id=648d1baa&"
import script from "./PreviewBox.vue?vue&type=script&lang=js&"
export * from "./PreviewBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports